/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Origin } from './Origin';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
    OriginToJSONTyped,
} from './Origin';
import type { EnrollmentStatus } from './EnrollmentStatus';
import {
    EnrollmentStatusFromJSON,
    EnrollmentStatusFromJSONTyped,
    EnrollmentStatusToJSON,
    EnrollmentStatusToJSONTyped,
} from './EnrollmentStatus';
import type { ClassEnrollmentActivity } from './ClassEnrollmentActivity';
import {
    ClassEnrollmentActivityFromJSON,
    ClassEnrollmentActivityFromJSONTyped,
    ClassEnrollmentActivityToJSON,
    ClassEnrollmentActivityToJSONTyped,
} from './ClassEnrollmentActivity';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { UserTaskStatus } from './UserTaskStatus';
import {
    UserTaskStatusFromJSON,
    UserTaskStatusFromJSONTyped,
    UserTaskStatusToJSON,
    UserTaskStatusToJSONTyped,
} from './UserTaskStatus';
import type { GetClassBaseResponse } from './GetClassBaseResponse';
import {
    GetClassBaseResponseFromJSON,
    GetClassBaseResponseFromJSONTyped,
    GetClassBaseResponseToJSON,
    GetClassBaseResponseToJSONTyped,
} from './GetClassBaseResponse';
import type { GetStudentBaseResponse } from './GetStudentBaseResponse';
import {
    GetStudentBaseResponseFromJSON,
    GetStudentBaseResponseFromJSONTyped,
    GetStudentBaseResponseToJSON,
    GetStudentBaseResponseToJSONTyped,
} from './GetStudentBaseResponse';

/**
 * 
 * @export
 * @interface GetEnrollmentResponse
 */
export interface GetEnrollmentResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetEnrollmentResponse
     */
    enrollmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {EnrollmentStatus}
     * @memberof GetEnrollmentResponse
     */
    status: EnrollmentStatus;
    /**
     * 
     * @type {Date}
     * @memberof GetEnrollmentResponse
     */
    updatedAt: Date;
    /**
     * 
     * @type {any}
     * @memberof GetEnrollmentResponse
     */
    statusChangedAt: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetEnrollmentResponse
     */
    enrolledAt: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetEnrollmentResponse
     */
    droppedAt: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetEnrollmentResponse
     */
    dropDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetEnrollmentResponse
     */
    rejectedAt: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetEnrollmentResponse
     */
    cancelledAt: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetEnrollmentResponse
     */
    completedAt: any | null;
    /**
     * 
     * @type {Origin}
     * @memberof GetEnrollmentResponse
     */
    origin: Origin;
    /**
     * 
     * @type {string}
     * @memberof GetEnrollmentResponse
     */
    processingTaskId: string | null;
    /**
     * 
     * @type {UserTaskStatus}
     * @memberof GetEnrollmentResponse
     */
    processingTaskStatus: UserTaskStatus | null;
    /**
     * 
     * @type {Array<ClassEnrollmentActivity>}
     * @memberof GetEnrollmentResponse
     */
    activityHistory: Array<ClassEnrollmentActivity>;
    /**
     * 
     * @type {GetClassBaseResponse}
     * @memberof GetEnrollmentResponse
     */
    _class: GetClassBaseResponse;
    /**
     * 
     * @type {GetStudentBaseResponse}
     * @memberof GetEnrollmentResponse
     */
    student: GetStudentBaseResponse;
    /**
     * 
     * @type {string}
     * @memberof GetEnrollmentResponse
     */
    reviewingByEmail?: string | null;
}



/**
 * Check if a given object implements the GetEnrollmentResponse interface.
 */
export function instanceOfGetEnrollmentResponse(value: object): value is GetEnrollmentResponse {
    if (!('enrollmentId' in value) || value['enrollmentId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('statusChangedAt' in value) || value['statusChangedAt'] === undefined) return false;
    if (!('enrolledAt' in value) || value['enrolledAt'] === undefined) return false;
    if (!('droppedAt' in value) || value['droppedAt'] === undefined) return false;
    if (!('dropDate' in value) || value['dropDate'] === undefined) return false;
    if (!('rejectedAt' in value) || value['rejectedAt'] === undefined) return false;
    if (!('cancelledAt' in value) || value['cancelledAt'] === undefined) return false;
    if (!('completedAt' in value) || value['completedAt'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('processingTaskId' in value) || value['processingTaskId'] === undefined) return false;
    if (!('processingTaskStatus' in value) || value['processingTaskStatus'] === undefined) return false;
    if (!('activityHistory' in value) || value['activityHistory'] === undefined) return false;
    if (!('_class' in value) || value['_class'] === undefined) return false;
    if (!('student' in value) || value['student'] === undefined) return false;
    return true;
}

export function GetEnrollmentResponseFromJSON(json: any): GetEnrollmentResponse {
    return GetEnrollmentResponseFromJSONTyped(json, false);
}

export function GetEnrollmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEnrollmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['enrollmentId']),
        'status': EnrollmentStatusFromJSON(json['status']),
        'updatedAt': (new Date(json['updatedAt'])),
        'statusChangedAt': json['statusChangedAt'],
        'enrolledAt': json['enrolledAt'],
        'droppedAt': json['droppedAt'],
        'dropDate': json['dropDate'],
        'rejectedAt': json['rejectedAt'],
        'cancelledAt': json['cancelledAt'],
        'completedAt': json['completedAt'],
        'origin': OriginFromJSON(json['origin']),
        'processingTaskId': json['processingTaskId'],
        'processingTaskStatus': UserTaskStatusFromJSON(json['processingTaskStatus']),
        'activityHistory': ((json['activityHistory'] as Array<any>).map(ClassEnrollmentActivityFromJSON)),
        '_class': GetClassBaseResponseFromJSON(json['class']),
        'student': GetStudentBaseResponseFromJSON(json['student']),
        'reviewingByEmail': json['reviewingByEmail'] == null ? undefined : json['reviewingByEmail'],
    };
}

export function GetEnrollmentResponseToJSON(json: any): GetEnrollmentResponse {
    return GetEnrollmentResponseToJSONTyped(json, false);
}

export function GetEnrollmentResponseToJSONTyped(value?: GetEnrollmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['enrollmentId']),
        'status': EnrollmentStatusToJSON(value['status']),
        'updatedAt': value['updatedAt'].toISOString(),
        'statusChangedAt': value['statusChangedAt'],
        'enrolledAt': value['enrolledAt'],
        'droppedAt': value['droppedAt'],
        'dropDate': value['dropDate'],
        'rejectedAt': value['rejectedAt'],
        'cancelledAt': value['cancelledAt'],
        'completedAt': value['completedAt'],
        'origin': OriginToJSON(value['origin']),
        'processingTaskId': value['processingTaskId'],
        'processingTaskStatus': UserTaskStatusToJSON(value['processingTaskStatus']),
        'activityHistory': ((value['activityHistory'] as Array<any>).map(ClassEnrollmentActivityToJSON)),
        'class': GetClassBaseResponseToJSON(value['_class']),
        'student': GetStudentBaseResponseToJSON(value['student']),
        'reviewingByEmail': value['reviewingByEmail'],
    };
}

